export default class FieldState {
    isRequired = false
    value = ""
    failedRequiredValidation = false

    constructor(isRequired, value = "") {
        this.isRequired = isRequired;
        this.value = value;
    }
}